module.exports = __webpack_public_path__ + "img/gallery03.d8661c61.jpg";